export default class SectionDataProcessMission {
    constructor(id, text) {
        this.id = id;
        this.missionText = text;
    }
}
